<template>
  <div class="the-detail">
    <div class="edit-page">
      <div class="title">
        <span v-show="web === 'add'">新增</span>
        <span v-show="web === 'edit'">编辑</span>
        <span v-show="web === 'detail'">详细</span>
      </div>
      <div class="el-form" label-position="top">
        <el-form ref="addForm" :model="addForm" label-width="120px" :rules="rules" :disabled="disabled">
          <el-row>
            <el-col :xs="24" :sm="24">
              <el-form-item label="公司名称" prop="companyName">
                <el-input type="text" size="small" v-model="addForm.companyName" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" v-if="addForm.id">
              <el-form-item label="公司编号" prop="comNum">
                <el-input type="text" size="small" :value="addForm.comNum" readonly placeholder="公司编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" v-if="$route.name === 'FlowDetail'">
              <el-form-item label="忽略词" prop="ignoreWord">
                <el-input type="text" size="small" v-model="addForm.ignoreWord" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="创建时间" prop="establishmentTime">
                <el-date-picker
                  size="small"
                  v-model="addForm.establishmentTime"
                  type="date"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item class="show-pc roleName" label="区域" prop="qy">
                <el-cascader
                  size="small"
                  class="width-100"
                  v-model="addForm.qy"
                  placeholder="请选择区域"
                  :props="{ value: 'label' }"
                  :options="options"
                  filterable
                  @change="qyChange"
                >
                </el-cascader>
              </el-form-item>
              <el-form-item v-show="web !== 'detail'" class="show-phone roleName" label="区域">
                <div @click="popupShow">
                  <el-input size="small" v-model="addForm.qy2" :disabled="true"></el-input>
                </div>
              </el-form-item>
              <el-form-item v-show="web == 'detail'" class="show-phone roleName" label="区域">
                <div>
                  <el-input size="small" v-model="addForm.qy2" :disabled="true"></el-input>
                </div>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="地址" prop="address">
                <el-input size="small" v-model="addForm.address" placeholder="请输入地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="纳税性质" prop="taxNature">
                <el-select size="small" v-model="addForm.taxNature" placeholder="请选择">
                  <el-option :label="item.name" :value="item.name" v-for="(item, index) in taxs" :key="'5-' + index">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="行业(可多选)" prop="industrie">
                <el-checkbox-group v-model="addForm.industrie" @change="industriesChange">
                  <el-checkbox label="生产"></el-checkbox>
                  <el-checkbox label="销售"></el-checkbox>
                  <el-checkbox label="研发"></el-checkbox>
                  <el-checkbox label="服务"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="信息类型" prop="infoType">
                <el-select size="small" v-model="addForm.infoType" placeholder="请选择">
                  <el-option label="公司转让" value="公司转让"></el-option>
                  <el-option label="资质转让" value="资质转让"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="注册资金" prop="registeredCapital">
                <el-input size="small" v-model="addForm.registeredCapital" placeholder="请输入注册资金"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="转让价格" prop="transferPrice">
                <el-input size="small" v-model="addForm.transferPrice" placeholder="请输入转让价格"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" v-if="$route.name !== 'FlowPublicDetail'">
              <el-form-item label="联系人" prop="linkman">
                <el-input size="small" v-model="addForm.linkman" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" v-if="$route.name !== 'FlowPublicDetail'">
              <el-form-item label="联系电话" prop="phone">
                <el-input size="small" v-model="addForm.phone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" v-if="$route.name === 'FlowDetail'">
              <el-form-item label="是否上架" prop="isPublic">
                <el-switch
                  v-model="addForm.isPublic"
                  active-color="#13ce66"
                  inactive-color="#aaa"
                  active-value="1"
                  inactive-value="0"
                  active-text="是"
                  inactive-text="否"
                >
                </el-switch>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item label="经营范围" prop="natureBusiness">
                <el-input size="small" type="textarea" v-model="addForm.natureBusiness"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24">
              <el-form-item class="form-item-phone-inline" label="图片" prop="wj">
                <span class="img-box" v-if="web === 'add' || web === 'edit'">
                  <!-- 选择按钮 -->
                  <div class="upload">
                    <div class="text"><i class="el-icon-plus"></i></div>
                    <input
                      type="file"
                      name="picJdcmp"
                      accept="image/*"
                      class="upload-file"
                      ref="picJdcmp"
                      @change="picRead"
                    />
                  </div>
                </span>
              </el-form-item>
              <el-form-item label-width="0">
                <div class="img-view" v-for="(pic, index) in pics" :key="index">
                  <el-image style="max-width: 200px" :fit="'contain'" :src="pic.url" :preview-src-list="[pic.url]">
                    <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
                  </el-image>
                  <i
                    class="el-icon-circle-close btn-close"
                    v-if="web === 'add' || web === 'edit'"
                    @click="delPic(index)"
                  ></i>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-form label-width="100px">
          <el-form-item class="btn">
            <slot name="button" v-bind:form="'addForm'"></slot>
          </el-form-item>
        </el-form>
        <slot name="audit" v-bind:form="'addForm'"></slot>
      </div>
    </div>
    <van-popup v-model="popupShowState" position="bottom" :style="{ height: '50%' }" :lazy-render="false">
      <van-picker
        ref="picker2"
        show-toolbar
        title="区域"
        :columns="options"
        cancel-button-text="清空"
        @confirm="pickerConfirm"
        @cancel="pickerCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import cityData from '../../../utils/Data'
export default {
  name: 'Detail',
  props: {
    addForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    pics: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      userInfo: {},
      titles: ['客户中心'],
      web: '',
      industries: [],
      taxs: [
        { code: '1', name: '小规模' },
        { code: '2', name: '一般纳税人' }
      ],
      options: [],
      options1: cityData,
      picJdcmp: { src: '', file: '', name: '图片' },
      popupShowState: false,
      minDate: new Date(1970, 0, 1),
      maxDate: new Date(2099, 0, 1),
      drawer: false,
      rules: {
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        ignoreWord: [{ required: true, message: '请输入忽略词', trigger: 'blur' }],
        infoType: [{ required: true, message: '请输入信息类型', trigger: 'blur' }],
        establishmentTime: [{ required: true, message: '请选择公司创建时间', trigger: 'change' }],
        registeredCapital: [{ required: true, message: '请输入注册资金', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        province: [{ required: true, message: '请输入省', trigger: 'change' }],
        city: [{ required: true, message: '请输入市', trigger: 'change' }],
        county: [{ required: true, message: '请输入县（区）', trigger: 'change' }],
        taxNature: [{ required: true, message: '请选择纳税性质', trigger: 'blur' }],
        transferPrice: [{ required: true, message: '请输入转让价格', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        linkman: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        natureBusiness: [{ required: true, message: '请输入警营范围', trigger: 'blur' }],
        isPublic: [{ required: true, message: '请选择是否上架', trigger: 'change' }],
        industrie: [{ required: true, message: '请选择行业', trigger: 'change' }]
      }
    }
  },
  methods: {
    // 区域选择框展示
    popupShow() {
      this.popupShowState = true
    },
    // 区域更改
    qyChange(val) {
      console.log(val)
      if (val) {
        this.addForm.province = val[0]
        this.addForm.city = val[1]
        this.addForm.county = val[2]
        this.addForm.qy = val
        this.addForm.qy2 = val.join('/')
        this.$refs.picker2.setValues(this.addForm.qy)
      }
    },
    industriesChange(val) {
      console.log(val)
      const industries = []
      if (val) {
        for (let i = 0; i < val.length; i++) {
          industries.push({
            industry: val[i]
          })
        }
        this.addForm.industries = industries
      }
    },
    // 区域选择确定
    pickerConfirm(val, indexs) {
      console.log(val)
      this.addForm.qy = val
      this.addForm.qy2 = val.join('/')
      this.addForm.province = val[0]
      this.addForm.city = val[1]
      this.addForm.county = val[2]
      this.popupShowState = false
      // if (val) {
      //   for (let i = 0; i < this.options.length; i++) {
      //     if (this.options[i].text === val[0]) {
      //       this.addForm.province = this.options[i].value
      //       for (let j = 0; j < this.options[i].children.length; j++) {
      //         if (this.options[i].children[j].text === val[1]) {
      //           this.addForm.city = this.options[i].children[j].value
      //           for (let k = 0; k < this.options[i].children[j].children.length; k++) {
      //             if (this.options[i].children[j].children[k].text === val[2]) {
      //               this.addForm.county = this.options[i].children[j].children[k].value
      //             }
      //           }
      //         }
      //       }
      //     }
      //   }
      // }
      console.log(this.addForm.province, this.addForm.city, this.addForm.county)
    },
    // 区域选择
    pickerCancel(val, indexs) {
      this.addForm.qy = val
      this.addForm.qy2 = val.join('/')
      this.addForm.province = val[0]
      this.addForm.city = val[1]
      this.addForm.county = val[2]
      this.popupShowState = false
    },
    /**
      查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changs = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.cycle = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    queryProvinceCity() {
      const param = {}
      this.$get('/system/queryProvinceCity', param).then(
        result => {
          if (result.status === 200) {
            this.options = result.data
            for (let i = 0; i < this.options.length; i++) {
              this.options[i].text = this.options[i].label
              for (let j = 0; j < this.options[i].children.length; j++) {
                this.options[i].children[j].text = this.options[i].children[j].label
                for (let k = 0; k < this.options[i].children[j].children.length; k++) {
                  this.options[i].children[j].children[k].text = this.options[i].children[j].children[k].label
                }
              }
            }
            const qy = [this.addForm.province, this.addForm.city, this.addForm.county]
            this.addForm.qy = qy
            this.$nextTick(() => {
              this.$refs.picker2.setValues(this.addForm.qy)
            })
            this.addForm.qy2 = qy.join('/')
          } else {
            // this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 图片预览
    picRead(e) {
      const _this = this
      var files = e.target.files[0]
      console.log(e)
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      const reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function() {
        _this[e.target.name] = {
          src: this.result,
          file: e.target.files[0]
        }
        _this.addForm[e.target.name] = e.target.files[0]
        _this.$refs[e.target.name].value = ''
        _this.uploadPic()
      }
    },
    // 上传图片
    uploadPic() {
      const param = new FormData()
      param.append('pic', this.addForm.picJdcmp)
      this.$formData('/flow/uploadPic', param).then(
        result => {
          if (result.status === 200) {
            this.pics.push({
              url: result.data.url
            })
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 删除图片
    delPic(index) {
      this.pics.splice(index, 1)
      console.log(this.pics)
    }
  },
  mounted() {
    this.web = this.$route.params.webState
    this.queryProvinceCity()
  },
  beforeDestroy() {
    this.$refs.addForm.resetFields()
  }
}
</script>

<style lang="less" scoped>
.edit-page,
.main-page {
  height: 100%;
}
.colspan {
  display: flex;
  span {
    flex: 1;
  }
}
.el-form-item {
  margin-bottom: 12px;
  /deep/.el-form-item__error {
    top: 85%;
  }
  /deep/.el-textarea + .el-form-item__error {
    top: 100%;
  }
}
.title {
  padding: 10px 20px;
  font-size: 18px;
}
.img-box {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 10vh;
    min-height: 10vh;
  }
  .upload {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    margin: 0 8px 8px 0;
    background-color: #f7f8fa;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
}
.img-view:first-child {
  margin-left: 50px;
}
.img-view {
  position: relative;
  display: inline-block;
  width: 45%;
  max-width: 150px;
  height: 80px;
  margin-right: 10px;
  /deep/.el-image {
    width: 100%;
    max-height: 80px;
  }
  .btn-close {
    position: absolute;
    right: -5px;
    top: -5px;
    background-color: #fff;
    border-radius: 50%;
    color: #409eff;
    cursor: pointer;
    font-size: 16px;
  }
}
.drawer-box {
  max-height: 100vh;
  overflow: auto;
  padding: 0 8px;
}

.the-detail {
  /deep/.el-checkbox__input.is-disabled + span.el-checkbox__label,
  /deep/.el-checkbox__input.is-disabled.is-checked .el-checkbox__inner,
  /deep/.el-input.is-disabled .el-input__inner,
  /deep/.el-textarea.is-disabled .el-textarea__inner {
    color: #333;
  }
}
@media screen and (max-width: 768px) {
  .the-detail {
    padding: 0 10px;
  }
  .img-view:first-child {
    margin-left: 0px;
  }
}
</style>
